function modalBlockConstructor($modalBlock) {
    var root = {
        id: $modalBlock.data('id'),
        $body: $('body'),

        init: function() {
            var _this = this;

            _this.$button = $('.open-modal-block[data-id=' + _this.id + ']');
            _this.$close = $modalBlock.find('.close');
            _this.$firstInput = $modalBlock.find('input:first-child');
            _this.$locationRequest = $('.open-location-request');

            _this.listener();
        },

        listener: function() {
            var _this = this;

            _this.$button.click(function(e) {
                e.preventDefault();
                _this.$firstInput.focus();
                _this.setVisible(true);
            });

            _this.$close.click(function() {
                _this.setVisible(false);
            });

            $modalBlock.click(function(e) {
                if ($(e.target).hasClass('modal-block')) {
                    _this.setVisible(false);
                }
            });

            _this.$locationRequest.click(function(e) {
                if (_this.id == 'event-missing') {
                    e.preventDefault();
                    _this.$firstInput.focus();
                    _this.setVisible(true);
                    var newurl =
                        window.location.protocol +
                        '//' +
                        window.location.host +
                        window.location.pathname +
                        '?location=Rotterdam';
                    window.history.replaceState({}, '', '?location=Rotterdam');
                }
            });
        },

        setVisible: function(isVisible) {
            var _this = this;
            $modalBlock.toggleClass('visible', isVisible);

            var prop = isVisible ? 'hidden' : '';
            _this.$body.css('overflow', prop);
        }
    };

    root.init();
}

var modalBlock = {
    $modalBlock: $('.modal-block'),

    init: function() {
        var _this = this;

        if (!_this.$modalBlock.length) {
            return;
        }

        _this.$modalBlock.each(function() {
            modalBlockConstructor($(this));
        });
    }
};
